export const ImageLink = (name) => {
    if (name) {
        const imageUrl = process.env.REACT_APP_IMG
        return `${imageUrl}${name}`;
    }
};
